import axios from "axios";
import config from "app/api/axiosConfig";
import { IPageContent } from "app/api/types/PageContent";

export default (token: string, data: IPageContent) =>
  axios.put(
    `${process.env.REACT_APP_API_HOST}/admin/page`,
    data,
    config(token)
  );
